<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listBanks"
        :title-table="$t('Banks')"
        module="bankSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_BANCO_INSERIR"
        view-permission="ROLE_BANCO_CONSULTAR"
        edit-permission="ROLE_BANCO_ATUALIZAR"
        delete-permission="ROLE_BANCO_DELETAR"
        @add="addNew"
        @edit="edit"
      >
        <template #buttons>
          <b-button
            v-if="verificarPermissao('ROLE_FINAN_INSERIR')"
            variant="outline-primary"
            class="ml-1"
            size="sm"
            @click="handleSync"
          >
            <feather-icon
              icon="RefreshCwIcon"
              class="mr-50"
            />
            Sincronizar FEBRABAN
          </b-button>
        </template>
      </TableComponents>
      <FormBank
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import {
  BRow, BCol, BButton, BImg,
} from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import mixinsGlobal from '@/mixins'
import FormBank from './forms/FormBank.vue'

export default {
  name: 'Bank',
  components: {
    BRow,
    BCol,
    BButton,
    BImg,
    TableComponents,
    FormBank,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('bankSettingsModule', {
      listBanks: state => state.listBanks,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Logo',
          field: 'logoUrl',
        },
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'descricao',
        },
        {
          label: 'Número',
          field: 'numero',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('bankSettingsModule/resetBank')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('bankSettingsModule/prepareToEditBank', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
    async handleSync() {
      const confirm = await this.$bvModal.msgBoxConfirm(
        'Deseja sincronizar a lista oficial de bancos do Brasil (FEBRABAN)? Isso pode atualizar nomes e logomarcas.',
        {
          title: 'Confirmar Sincronização',
          okVariant: 'primary',
          okTitle: 'Sim, Sincronizar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-secondary',
        },
      )

      if (confirm) {
        try {
          await this.$store.dispatch('bankSettingsModule/syncFebraban')
          this.showMessageSuccess(
            'Sincronização',
            'Processo concluído com sucesso!',
          )
          // We need to reload the table. If TableComponents handle this via its own refresh, fine.
          // Usually, we emit something or rely on reactive store.
          window.location.reload() // Quick fix to ensure data reload if TableComponents is not reactive to store content change automatically
        } catch (error) {
          this.MensagemError('Erro', 'Falha ao sincronizar com FEBRABAN.')
        }
      }
    },
  },
}
</script>
